import {
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  Button
} from "@material-ui/core";
import avatar from "assets/img/faces/avatar1.jpg";
import GridItem from "components/Grid/GridItem.jsx";
import { GetUserToken } from "helpers/UserHelper";
import { ClientProfileSummary } from "queries/clients/queries";
import React from "react";
import { Query } from "react-apollo";
import QuoteFieldMap from "../../maps/QuoteFieldMap";

const LeftRight = props => (
  <React.Fragment>
    <GridItem xs={6} sm={6} md={6} style={props.style}>
      <Typography
        variant="body1"
        style={{
          textAlign: "right",
          fontWeight: "500",
          color: "rgba(0, 0, 0, 0.54)"
        }}
      >
        {props.left}
      </Typography>
    </GridItem>
    <GridItem xs={6} sm={6} md={6} style={props.style}>
      <Typography
        variant="body2"
        style={{ textAlign: "left", wordBreak: "break-word" }}
      >
        {props.right}
      </Typography>
    </GridItem>
  </React.Fragment>
);

const LeftLeft = props => (
  <Grid container style={{ marginBottom: "10px" }}>
    <Grid
      item
      xs={4}
      sm={4}
      md={4}
      style={{ ...props.style, paddingRight: "5px" }}
    >
      <Typography
        variant="body1"
        style={{
          textAlign: "Left",
          fontWeight: "500",
          color: "rgba(0, 0, 0, 0.54)"
        }}
      >
        {props.left}
      </Typography>
    </Grid>
    <Grid
      item
      xs={8}
      sm={8}
      md={8}
      style={{ ...props.style, paddingLeft: "5px" }}
    >
      <Typography
        variant="body2"
        style={{ textAlign: "left", wordBreak: "break-word" }}
      >
        {getMappedOrDefault(props.right)
          ? getMappedOrDefault(props.right)
          : "N/A"}
      </Typography>
    </Grid>
  </Grid>
);

const getMappedOrDefault = value => {
  if (!value) return null;

  const mapped = QuoteFieldMap[value];
  if (mapped) return mapped;

  return value;
};

class ClientDetailCard extends React.Component {
  state = { showQuoteDetails: false };

  toggleShowQuoteDetails = () => {
    this.setState(prevState => ({
      showQuoteDetails: !prevState.showQuoteDetails
    }));
  };

  render() {
    return (
      <Query
        query={ClientProfileSummary}
        variables={{
          id: this.props.clientId,
          token: GetUserToken()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <Card>
                <CardContent>
                  <LinearProgress />{" "}
                </CardContent>
              </Card>
            );
          }

          var client = data.ClientProfileSummary;

          return (
            <React.Fragment>
              <Card>
                <CardContent>
                  <Typography
                    variant="title"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <span style={{ textTransform: "capitalize" }}>
                      {client.scd_title ? client.scd_title.toLowerCase() : ""}
                    </span>
                    {". "}
                    {client.scd_name} {client.scd_surname}
                  </Typography>
                  <div
                    style={{
                      marginTop: "15px",
                      width: "100%",
                      textAlign: "center",
                      display: "block"
                    }}
                  >
                    <img
                      className="avatarImg"
                      src={
                        client.scd_pp_path && client.scd_pp_path.trim !== ""
                          ? client.scd_pp_path
                          : avatar
                      }
                      alt="..."
                      style={{
                        margin: "0px auto",
                        width: "100px",
                        height: "100px",
                        objectFit: "cover"
                      }}
                    />
                  </div>
                  <Grid container style={{ marginTop: "30px" }}>
                    <LeftRight left="Name" right={client.scd_name} />
                    <LeftRight left="Surname" right={client.scd_surname} />
                    {client.scd_initials ? (
                      <LeftRight left="Initials" right={client.scd_initials} />
                    ) : null}
                    {client.scd_email ? (
                      <LeftRight left="Email" right={client.scd_email} />
                    ) : null}
                    {client.scd_cellNumber ? (
                      <LeftRight
                        left="Cell Number"
                        right={client.scd_cellNumber}
                      />
                    ) : null}

                    <LeftRight
                      style={{ marginTop: "15px" }}
                      left="Active/Prospect"
                      right={
                        client.scd_clientType === "active" ? (
                          <Typography>Active</Typography>
                        ) : client.scd_clientType === "prospect" ? (
                          <Typography>Prospect</Typography>
                        ) : (
                          <Typography>N/A</Typography>
                        )
                      }
                    />
                    <LeftRight
                      left="App Status"
                      right={
                        client.app_active === 1 ? (
                          <Typography>Active</Typography>
                        ) : client.invite_sent === 1 ? (
                          <Typography>Invite Sent</Typography>
                        ) : (
                          <Typography>Not Active</Typography>
                        )
                      }
                    />
                  </Grid>

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "15px",
                      display: "block"
                    }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      color="secondary"
                      style={{
                        margin: "10px auto 10px auto",
                        width: "65%"
                      }}
                      onClick={() =>
                        this.props.history.push({
                          pathname: "/app/EditClient",
                          search: `clientId=${this.props.clientId}`
                        })
                      }
                    >
                      Edit Client
                    </Button>

                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      style={{
                        margin: "10px auto 10px auto",
                        width: "65%"
                      }}
                      onClick={this.toggleShowQuoteDetails}
                    >
                      {`${
                        !this.state.showQuoteDetails ? "Show" : "Hide"
                      } Quote Related Fields`}
                    </Button>
                  </div>
                </CardContent>
              </Card>

              {!this.state.showQuoteDetails ? null : (
                <Card style={{ margin: "10px auto 10px auto" }}>
                  <CardContent>
                    <Typography
                      variant="subheading"
                      className="centerCell"
                      style={{ marginBottom: "15px" }}
                    >
                      Other Quoting Related Fields
                    </Typography>
                    <LeftLeft
                      left="Date of birth"
                      right={client.scd_dateOfBirth}
                    />
                    <LeftLeft left="Gender" right={client.scd_gender} />
                    <LeftLeft left="Smoker" right={client.scd_smoker} />
                    <LeftLeft
                      left="Marital Status"
                      right={client.scd_maritalStatus}
                    />
                    <LeftLeft left="Occupation" right={client.scd_occupation} />
                    <LeftLeft
                      left="Highest qualification"
                      right={client.scd_qualification}
                    />
                    <LeftLeft
                      left="Self Employed"
                      right={client.scd_selfEmployed}
                    />
                    <LeftLeft
                      left="Commission or Fixed Salary"
                      right={client.scd_salaryType}
                    />
                    <LeftLeft
                      left="Monthly income"
                      right={
                        client.scd_monthlyIncome
                          ? `R${client.scd_monthlyIncome}`
                          : null
                      }
                    />
                    <LeftLeft
                      left="Tax dispensation"
                      right={client.scd_taxDispensation}
                    />
                    <LeftLeft
                      left="Spouse Monthly Income"
                      right={
                        client.scd_spouseIncome
                          ? `R${client.scd_spouseIncome}`
                          : null
                      }
                    />

                    <LeftLeft
                      left="Admin"
                      right={client.scd_pAdmin ? `${client.scd_pAdmin}%` : null}
                    />
                    <LeftLeft
                      left="Travel"
                      right={
                        client.scd_pTravel ? `${client.scd_pTravel}%` : null
                      }
                    />
                    <LeftLeft
                      left="Manual Labour"
                      right={
                        client.scd_pManual ? `${client.scd_pManual}%` : null
                      }
                    />
                    <LeftLeft
                      left="Supervision"
                      right={
                        client.scd_pSupervision
                          ? `${client.scd_pSupervision}%`
                          : null
                      }
                    />
                  </CardContent>
                </Card>
              )}
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default ClientDetailCard;



// WEBPACK FOOTER //
// ./src/views/Clients/ClientDetail/components/ClientDetailCard.jsx